export class ErrorVisibilityManager {
    static manageErrorVisibility(element: HTMLInputElement | HTMLTextAreaElement, isValid: boolean) {
        if (isValid) {
            this.hideFieldError(element)
            return true
        } else {
            this.showFieldError(element);
            return false
        }
    }

    static showFieldError(element: HTMLInputElement | HTMLTextAreaElement) {
        this.showInputError(element);
        this.showDefaultDivError(element);
    }

    static hideFieldError(element: HTMLInputElement | HTMLTextAreaElement) {
        this.hideInputError(element);
        this.hideDefaultDivError(element);
    }

    static showDefaultDivError(element: HTMLInputElement | HTMLTextAreaElement) {
        this.getDefaultErrorMessageElement(element)?.classList.add('active');
    }

    static hideDefaultDivError(element: HTMLInputElement | HTMLTextAreaElement) {
        this.getDefaultErrorMessageElement(element)?.classList.remove('active');
    }

    static getInputContainer(element: HTMLInputElement | HTMLTextAreaElement) {
        return element.closest('.adform-input-wrapper')
    }

    static showInputError(element: HTMLInputElement | HTMLTextAreaElement) {
        element.classList.add('invalid');
    }

    static hideInputError(element: HTMLInputElement | HTMLTextAreaElement) {
        element.classList.remove('invalid');
    }

    private static getDefaultErrorMessageElement(element: HTMLInputElement | HTMLTextAreaElement) {
        return this.getInputContainer(element)?.querySelector('.error-text')
    }
}
